module.exports = __webpack_public_path__ + "img/icon_map_199_on_101.57a9758a.png";